export enum CollaboratorInviteStatus {
  Draft = 'DRAFT',
  RequestSent = 'REQUEST_SENT',
  Confirmed = 'CONFIRMED',
  NoAccess = 'NO_ACCESS'
}

export const CollaboratorInviteStatusDisplay: { [key in CollaboratorInviteStatus]: string } = {
  [CollaboratorInviteStatus.Draft]: 'Draft',
  [CollaboratorInviteStatus.RequestSent]: 'Request Sent',
  [CollaboratorInviteStatus.Confirmed]: 'Confirmed',
  [CollaboratorInviteStatus.NoAccess]: 'No Access'
};

export interface Collaborator {
  id: string;
  name: string;
  email: string;
  status: CollaboratorInviteStatus;
}

export interface PermissionSetting {
  none: boolean;
  view: boolean;
  edit: boolean;
}

export interface ShopPermission {
  overview: PermissionSetting;
  salesAndProfit: PermissionSetting;
  inventory: PermissionSetting;
  profitAndLoss: PermissionSetting;
  manualAdjustments: PermissionSetting;
  [key: string]: PermissionSetting;
}

export interface ShopAccess {
  shopId: string;
  permissions: ShopPermission | null;
  hasAccess: boolean;
}

export interface CollaboratorDetails {
  name: string;
  email: string;
  status: CollaboratorInviteStatus;
  shops: ShopAccess[];
}

export interface CollaboratorStateModel {
  collaborators: Collaborator[];
  collaboratorPermissions: Record<string, CollaboratorPermission[]>;
  selectedCollaboratorDetails: CollaboratorDetails | null;
  loading: boolean;
  error: string | null;
  dataLoaded: boolean;
}

export interface CollaboratorPermission {
  shopId: string;
  hasAccess: boolean;
  permissions: ShopPermission | null;
}

export interface CollaboratorInfoResponse {
  success: boolean;
  message: string;
  data: {
    name: string;
    email: string;
    status: string;
  };
}
